import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { LayoutModule } from './theme/layouts/layout.module';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { AppComponent } from './app.component';
import { ScriptLoaderService, ScriptLoaderServiceBase } from "./Shared/service/script-loader.service";
import { FormsModule } from '@angular/forms';

import { HttpModule} from '@angular/http'
import { HttpClientModule } from '@angular/common/http';

import { HomeComponent } from './Home/component/Home';
import {OAuthModule, OAuthService} from 'angular-oauth2-oidc';
import { ClientSideUtility } from './Shared/service/ClientSideUtility';
import { HttpUtility } from './Shared/service/HttpUtility';
import { ConfigurationReaderBase, ConfigurationReader } from './Shared/service/ConfigurationReader';
import { MainNavigationBase, MainNavigationService } from './Shared/service/MainNavigation.service';
import { AuthenticationBase, Authentication } from './Shared/service/Authentication';
import { AuthGuard} from './Shared/service/AuthGuard'
import { CommonServiceBase, CommonService } from './Shared/service/CommonService';
import { appRouter } from './app.router';
import { UserProfileComponent } from './Home/component/UserProfile';
import { EqualValidator } from './Shared/directives/equalvalidator';
import { FAQComponent } from './Home/component/faq';

@NgModule({
    declarations: [        
        AppComponent,    
        HomeComponent,
        EqualValidator,
        UserProfileComponent,
        FAQComponent
    ],
    imports: [
        LayoutModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpModule,
        HttpClientModule,
        OAuthModule.forRoot(),
        appRouter    
    ],
    providers: [
        {provide:ScriptLoaderServiceBase, useClass:ScriptLoaderService},
        OAuthService,
        ClientSideUtility, 
        HttpUtility,    
        AuthGuard,
        {provide:MainNavigationBase, useClass:MainNavigationService},
        {provide:ConfigurationReaderBase, useClass:ConfigurationReader},
        {provide:AuthenticationBase, useClass:Authentication},
        {provide:CommonServiceBase, useClass:CommonService} ,        
        {provide: APP_INITIALIZER, useFactory: (config: ConfigurationReaderBase) => () => config.loadConfig(), deps: [ConfigurationReaderBase], multi: true }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }


// WEBPACK FOOTER //
// D:/a/1/s/src/app/app.module.ts